import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RouteConstants } from 'src/app/constants/route-constants';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';

@Component({
  selector: 'app-account-create-success',
  templateUrl: './account-create-success.component.html',
  styleUrl: './account-create-success.component.css'
})
export class AccountCreateSuccessComponent {
  userType:string = AppSessionStorageService.registerUserType;
  appRedirectionLink = AppSessionStorageService.appRedirctionLink

  constructor(private readonly router: Router) {
    }

  isCustomer():boolean{
    console.log(this.appRedirectionLink)
    if(this.userType == ''){
      this.router.navigate([RouteConstants.SIGNIN], { replaceUrl: true });
    }
    else if(this.userType === "customer"){
      return true
    }
    return false
  }
}
